<centric-card [shadow]="true">
	<centric-card-header>
		<div centric-card-title>{{ 'dashboard.transactions.title' | translate }}</div>
		<windmill-combo-button
			[menuItems]="dashboardService.dropdownData"
			[contentType]="'dropdown'"
			[dropdownButtonText]="activeTimePeriod | translate"
			[dropdownType]="'uncontained-greyscale'"
			(menuItemSelected)="onTimePeriodChange($event)"
			[disabled]="!isSupplierActive">
		</windmill-combo-button>
	</centric-card-header>
	<div centric-card-content>
		<frontend-transaction-chart #transactionChart> </frontend-transaction-chart>
	</div>
</centric-card>
